(function(){
  function getBanner(){
    return document.getElementById('nt_bogo_banner');
  }

  function cartHasBogo(cart){
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var discounts = items[i].discounts || [];
      if (discounts.length > 0) return true;
    }
    if (cart && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) return true;
    return false;
  }

  function updateBogoBanner(cart){
    var el = getBanner();
    if (!el) return;
    var shouldShow = cartHasBogo(cart);
    var isHidden = el.classList.contains('dn');
    if (shouldShow) {
      if (isHidden) {
        el.classList.remove('dn');
        el.classList.remove('nt_bogo_pop');
        void el.offsetWidth;
        el.classList.add('nt_bogo_pop');
      }
    } else {
      el.classList.add('dn');
      el.classList.remove('nt_bogo_pop');
    }
  }

  function checkCartForBogo(){
    fetch('/cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'})
      .then(function(r){ return r.json(); })
      .then(updateBogoBanner)
      .catch(function(){});
  }

  var CART_URL_RE = /\/cart\/(add|change|update|clear)/;

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function(){
      var args = arguments;
      var url = args[0];
      var urlStr = (typeof url === 'string') ? url : (url && url.url) || '';
      var p = origFetch.apply(this, args);
      if (CART_URL_RE.test(urlStr)) {
        p.then(function(res){ setTimeout(checkCartForBogo, 150); return res; })
         .catch(function(err){ setTimeout(checkCartForBogo, 150); throw err; });
      }
      return p;
    };
  }

  try {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url){
      this.__nt_cart_url = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function(){
      var xhr = this;
      if (xhr.__nt_cart_url && CART_URL_RE.test(xhr.__nt_cart_url)) {
        xhr.addEventListener('loadend', function(){ setTimeout(checkCartForBogo, 150); });
      }
      return origSend.apply(this, arguments);
    };
  } catch(e) {}

  document.addEventListener('DOMContentLoaded', checkCartForBogo);
  if (document.readyState !== 'loading') { checkCartForBogo(); }
})();
